import { useEffect } from "react";
import socketServices from "./socketService";
import { useAppSelector } from "src/redux/redux-hooks";

const useRefreshBetList = (refreshApiFun: () => void, shouldFetchAuto: boolean = true) => {
  const { oddsSocketConnected } = useAppSelector((state) => state.socket);

  useEffect(() => {
    if (oddsSocketConnected && shouldFetchAuto && refreshApiFun) {
      socketServices.socketError();
      socketServices.chekUserConnected(() => {
        socketServices.refreshBetList(refreshApiFun);
      });
    }
  }, [refreshApiFun, oddsSocketConnected, shouldFetchAuto]);

  return { oddsSocketConnected };
};

export default useRefreshBetList;
